var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTwitterLogo = function SvgTwitterLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 10v.8c0 8-6.2 17.2-17.5 17.2-3.5 0-6.7-1-9.4-2.7.5.1 1 .1 1.5.1 2.9 0 5.5-1 7.6-2.6-2.7-.1-5-1.8-5.7-4.2.4.1.8.1 1.2.1.6 0 1.1-.1 1.6-.2-2.8-.6-4.9-3-4.9-5.9v-.1c.8.5 1.8.7 2.8.8-1.7-1.1-2.7-2.9-2.7-5 0-1.1.3-2.1.8-3 3 3.7 7.6 6.1 12.7 6.3-.1-.4-.2-.9-.2-1.4 0-3.3 2.8-6.1 6.2-6.1 1.8 0 3.4.7 4.5 1.9 1.4-.3 2.7-.8 3.9-1.5-.5 1.4-1.4 2.6-2.7 3.4 1.2-.1 2.4-.5 3.5-1-.9 1.2-2 2.2-3.2 3.1z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })));
};
export default SvgTwitterLogo;